var MessageEn = {

  NavabarText: {
    navbar_about: "About Us",
    navbar_item: "Genetic Test",
    navbar_search: "Report",
    navbar_searchy: "Maternal Serum Screening Report",
    navbar_searchys: "MTHFR Gene Test Report",
    navbar_contact: "Contact Us",
    navbar_newinformation: "News",
    navbr_jiyin: "Gene Blog",
    banner_text_tip: "Test and Technology",
  },
  indexText: {
    more: "Learn more",

  },
  ContractText: {
    company_full_name: "First Choice (Hong Kong) Medical Laboratory",
    // company_address: "Unit 01, 8/F, CCT Telecom Building 11 Wo Shing Street, Fo Tan, New Territories, Hong Kong ",

    company_address: "Unit S, Floor 9, Valiant Industrial Centre, 2-12 Au Pui Wan Street, Fo Tan, N.T., Hong Kong",
    address: "Address",
    tel: "Tel",
    fax: "Fax",
    email: "E-mail",
    web: "Website",

    quickContactYou: "Our customer service representative will contact you shortly",
    namemust: "Name (required)",
    phonemust: "Phone No. (required)",
    emailmust: "Email (required)",
    topic: "Topic",
    content: "content",

    mailbox_title: "Consultation mailbox",
    mailbox_subtitle: "【Click to apply for membership】",
    mailbox_type: "Types of consultation",
    mailbox_type_1: "Customer consultation",
    mailbox_type_2: "Cooperation consultation",
    mailbox_sex_mr: "Mr",
    mailbox_sex_mrs: "Mrs",
    mailbox_sex_lady: "Lady",
    mailbox_surname: "Surname",
    mailbox_tel_phone: "Telephone：",
    mailbox_email: "E-mail ：",
    mailbox_message: "leave a message：",
    mailbox_btn: "Confirm",


    code: "ID Number",
    labno: "Laboratory No.",
    name: "Test Requester",
    phone: "Telephone",
    vertify: "Captcha",
    vertifys: "Captcha",
    send_sms: "Send",
    send_sms_second: "Send Again",

    vertify_placeholder: "Please enter your cell phone number",
    phone_placeholder: "PLEASE ENTER THE CAPTCHA",

    tech_title: "Cooperation partners",
    medical: "Medical institutions",
    physical: "Physical Examination Center",
    individual: "Individual",
    organization: "Nov-profit organizations",
    doctor: "Doctor",
    warning: "I acknowledge that I have read and ",
    private: 'agree the privacy policy.',
    speaker: "voice verification",
    report_search_description: "Instructions for Maternal Serum Screening Report Verification：",
    description_one: "Report verification is available at 12:00, the next day of report releasing.",
    description_two: "Please ensure the name and Laboratory No. you input is consistent with that on the report.",
    description_three: "Input your mobile phone number based on instructions, and then click 'Send' you will receive the five-digit verification code.",
    description_four: "Input the five-digit verification code and click 'submit', then you will see the report successfully.",
    description_five: "Please try the voice verification if no SMS verification code is received.",
    report_search_descriptionys: "Instructions for MTHFR Gene Test Report Verification：",
    description_oneys: "Report verification is available at 12:00, the next day of report releasing.",
    description_twoys: "Please ensure the name and Laboratory No. you input is consistent with that on the report.",
    description_threeys: "Input your mobile phone number based on instructions, and then click 'Send' you will receive the five-digit verification code.",
    description_fourys: "Input the five-digit verification code and click 'submit', then you will see the report successfully.",
    description_fiveys: "Please try the voice verification if no SMS verification code is received.",
    verson: "All rights reserved",
    termsofuse: "Terms of use",
    privacypolicy: "Privacy policy",
    addressfoot: "Unit S, Floor 9, Valiant Industrial Centre, 2-12 Au Pui Wan Street, Fo Tan, N.T., Hong Kong",
    servicetime: "Service Time",
    newinfo: "News",
    GeneUniverse: "Gene Blog",
    ContactUs: "Contact Us",
    aboutus: "About Us",
    TestingService: "Services",
    CompanyName: "First Choice (Hong Kong) Medical Laboratory",
    weeks: "Monday – Friday",
    saturday: "Saturday",
    holidays: "Sundays and public holidays",
    Y_chromosome: "Y-Chromosome DNA Test",
    PrenatalTesting: "Non-invasive Prenatal Test",

    CancerReal: "Cancer Monitoring",
    Prenatal_Paternity_Testing: "Non-invasive Prenatal Paternity Test",
    genetic_tumor: "Hereditary Cancer Screening",
    genetesting: "Talent Gene Test",
    Thalassemia: "Thalassemia gene detection",
    Vaccine: "Vaccine Antibody Test",
    Detection_diseases: "Monogenic Disease Screening",
    aboutzhouxin: "About Us",
    technology: "Technology",
    qualification: "Accreditation & Recognition",
    mediacenter: "Media",
    cooperation: "Partnership",
    recruitment: "Career",
    reproductivehealth: "Reproductive Health",
    Y_chromosome_maternal_blood: "Y-chromosome DNA Test",
    Noninvasiveprenataltesting: "Non-invasive Prenatal Test",
    Noninvasive_prenatal_paternity_test: "Non-invasive Prenatal Paternity Test",
    Paternity_testing: "Paternity Test",
    Fragile_X_syndrome_screening: "Fragile X syndrome screening",
    Detection_of_monogenic_genetic_diseases: "Monogenic Disease Screening",
    cancer: "Cancer",
    Genetic_tumor_detection: "Hereditary Cancer Screening",
    Cancer_real_time_monitoring: "Cancer Monitoring",
    Infectious_diseases: "Infectious Diseases",
    Vaccine_antibody_test: "Vaccine Antibody Test",
    STD_quick_test: "STI Rapid Test",
    Talent_gene_testing: "Talent Gene Testing",
    Noninvasive_prenatal_testing: "Noninvasive prenatal testing",
    Health_and_disease_risk: "Health & Disease Risk",
    Yreport: 'Maternal Serum Screening',
    MTHFRreport: 'MTHFR Gene Test',


  },

  GensUniverseText: {

    gens_tip_1: "Pregnant women without Immunity suffer from the most serious measles abortion",
    gens_content_1: "The measles epidemic in Hong Kong at the beginning of this year was very serious. Although it is under control now, all sectors should not take it lightly.",
    gens_tip_2: "Noninvasive blood sampling for cancer is suitable for elderly patients",

    gens_content_2: "When it comes to cancer testing, biopsies often discourage many people. However, with the rapid development of medicine, non-invasive methods can be used to detect cancer, and this technology is becoming more mature, reducing risks and costs, and benefiting more people.",


    gens_tip_3: "The most easily overlooked allergic food",

    gens_content_3: "Many parents say that children have food allergies. How common are they? How much do you know about children's food allergies?",

    gens_tip_4: "Optimistic women have a greater chance of giving birth",

    gens_content_4: "A British study found that women with optimistic personalities and relaxed lives are more likely to have a boy when they are pregnant. It is suggested that women who want to have a baby boy should be more optimistic and have a good physique.",


    gens_tip_5: "A twin is a mother and a father",

    gens_content_5: "A couple in Xiamen, Fujian Province, went to do a paternity test because they wanted to help their twin sons register, but it turned out that the twins were 'half brothers'",


    gens_tip_6: "It has been confirmed that the extension of NIPT detection range to chromosome deletion and duplication is an urgent clinical need",

    gens_content_6: "With the continuous accumulation of clinical data and the improvement of analytical technology, the clinical application of noninvasive prenatal testing (NIPT) is bound to be more extensive in the future, which will also be a great blessing for pregnant women and fetuses.",


    gens_tip_7: "Comprehensive cancer gene analysis breaks through the dilemma of no medicine to cure",

    gens_content_7: 'For some cancers, such as lung cancer and breast cancer, the results of gene testing will directly affect the treatment plan, so doctors generally recommend patients to carry out gene testing at the same time of diagnosis, grasp the time, and start using "right" drugs as early as possible.',


    gens_tip_8: "Will the body still produce antibodies after inoculating the problem vaccine?",

    gens_content_8: "The repeated vaccine events make parents worried and lose confidence in the efficacy of the vaccine. Many parents try to test the antibody for children, hoping to make sure that the vaccine injected before produces enough antibody to protect children.",


    gens_tip_9: "How do genes affect talent potential?",

    gens_content_9: "What is the basis of judging children's relevant talents in the talent gene test report?",


    gens_tip_10: "Shaw Prize winning scientists predict that the risk of breast cancer in Chinese women will continue to rise",

    gens_content_10: "Breast cancer is the most common cancer among women in Hong Kong. A scientist predicted that in China and Hong Kong, the number of women suffering from breast cancer will only increase.",


    gens_tip_11: "The status of birth examination and termination of pregnancy of Hong Kong pregnant women with disappearing Down's syndrome",

    gens_content_11: "Down's syndrome may disappear in Iceland due to the relationship between prenatal examination and termination of pregnancy, so what's the situation in Hong Kong?",


    gens_tip_12: "It's difficult to trace the rare genetic diseases",

    gens_content_12: "Genetic diseases can be passed on from generation to generation, and genetic experts, like detectives, can use gene detection and other technologies to explore the hidden genetic code in the pre marital or prenatal examination stage, so as to reduce the incidence of disease and related complications.",


    gens_tip_13: "The number of cancer detection periods before NPC screening research of 20000 people in CUHK has been completed",

    gens_content_13: "The Chinese University of Hong Kong recently completed a study involving 20000 people to determine that by analyzing EBV DNA in the plasma, NPC can be diagnosed as early as possible before there is any symptom.",

  },

  HomeText: {
  //   BannerTip_1_1: "6",
  //   BannerTip_1_2: "週",
  //   BannerTip_1_3: "即",
  //   BannerTip_1_4: "可",
  //   BannerTip_1_5: "檢",
  //   BannerTip_1_6: "測",
  //   BannerTip_1_Left: "Y-染色體母血篩選",
  //   BannerTip_1_Right: "最快當日出結果",

    BannerTip_2_1: "基",
    BannerTip_2_2: "因",
    BannerTip_2_3: "角",
    BannerTip_2_4: "度",
    BannerTip_2_5: "度",
    BannerTip_2_6: "身",
    BannerTip_2_7: "打",
    BannerTip_2_8: "造",
    BannerTip_2_Left: "天賦基因檢測選",
    BannerTip_2_Right: "掌握天賦潛能",

    BannerTip_3: "榮獲ISO9001國際品質認證",
    BannerTip_3_Left: "香港卓信醫療化驗所",
    BannerTip_3_Right: "因為卓越．值得信賴",
    BannerTip_4: '荣获「商界展关怀」殊荣',


    GeneticTests: "Genetic Tests",
    GeneticButton: "Test List",
    ReproductiveHealth: "Celebrate new life",
    ReproductiveHealth2: "Make sure your baby is healthy",
    Cancer: "Early cancer detection",
    Cancer2: "Better survival",
    InfectiousDisease: "Protect yourself and your loved one",
    InfectiousDisease2: "Stay away from infections",
    HealthyLife: "Discover yourself genetically",
    HealthyLife2: "Unleash your inborn potential",

    GeneticTestsSubtitleButton: "Learn More",
    GeneticTestsSubtitle1: "Save lives with technology",
    GeneticTestsSubtitle1Detail: "Our strong team and world-leading technology",
    GeneticTestsSubtitle1Detail2: "allow you to control your health through genes",
    GeneticTestsSubtitle2: "Trustworthy through our profession",
    GeneticTestsSubtitle2Detail: "As a registered medical laboratory in Hong Kong,",
    GeneticTestsSubtitle2Detail2: "our ISO accreditation gives you confidence",
    ServingLocalClinics: "SERVING LOCAL CLINICS",
    SamplesProcesses: "SAMPLES PROCESSES",
    LatestGeneticInformation: "Latest Genetic Information",
  },

  AboutFCLAB: {
    Title: "About Us",
    FirstChoiceMedicalLaboratory: "First Choice (Hong Kong) Medical Laboratory",
    FirstChoiceMedicalLaboratoryDetail: "Excellence deserves your trust.",
    FirstChoiceMedicalLaboratoryDetail2: "By providing high-quality genetic tests and timely services, we are your “First Choice”.",
    Mission: "Mission",
    MissionDetail: "Combine innovative ideas with cutting-edge technology to provide customers with the most professional and accurate genetic tests.",
    MissionDetail2: "Develop and apply the latest genetic and genomic technologies to make more people aware of the power of healthcare.",
    CoreCulture: "Core Culture",
    Professional: "Professional",
    ProfessionalDetail: "Provide professional and accurate DNA tests to benefit customers",
    Honest: "Honest",
    HonestDetail: "Communicate with customers and build trust between us",
  },

 // 新加FCLAB简介用于优化
 aboutFCLAB: {
  Title: "卓信化验所简介",
  FirstChoiceMedicalLaboratory: "公司简介",
  FirstChoiceMedicalLaboratoryDetail: "香港卓信医疗化验所有限公司，2017年10月27日成立于香港，公司编号2598283,主要提供基因检测服务。是香港少数获得ISO认证的医疗化验所。地址位于香港新界火炭坳背灣街2-12號威力工業中心9樓S室。 专业的一级医务化验师于香港医务化验师管理委员会注册，监管样本处理流程及签发化验报告。专注基因检测，提供无创产前检测、亲子鉴定、单基因遗传病、遗传性肿瘤检测、癌症实时监控、疫苗抗体检测、首创的genecode天赋基因检测等，受到客户信赖。",
  
  Mission: "产品服务",
  MissionDetail: "香港卓信医疗化验所有限公司专注基因检测，主要提供以下4大类基因检测 ",
  MissionDetail2: "生育健康",
  MissionDetail3: "无创产前检测、无创产前亲子鉴定、亲子鉴定、单基因遗传病等",
  MissionDetail4: "癌症",
  MissionDetail5: "遗传性肿瘤检测、癌症实时监控等 ",
  MissionDetail6: "传染病",
  MissionDetail7: "疫疫苗抗体检测，性病快速测试等 ",
  MissionDetail8: "天赋基因检测",
  MissionDetail9: "首创genecode天赋基因检测 ",
  MissionDetail10: "叶酸代谢基因检测",
  MissionDetail11: "通过对MTHFR基因其相关位点的检测，根据个人情况选择叶酸补充途径。(检测需时：1个工作日，支持网上查报告)",
  MissionDetail12: "公司理念",
  MissionDetail13: "因为卓越，所以值得信赖。",
  MissionDetail14: "更高质素的基因检测科技，更方便快捷的服务，成为顾客的最佳选择。",
  MissionDetail15: "公司使命",
  MissionDetail16: "结合创新的思维、崭新的基因检测科技，为顾客提供最专业和最精准的检测。",
  MissionDetail17: "开发和应用最新的遗传和基因组科技，让更多人意识到医疗保健的力量。",
  MissionDetail18: "发展历程",
  MissionDetail19: "2017年10月27日，香港卓信医疗化验所有限公司注册成立。",
  MissionDetail20: "香港卓信医疗化验所有限公司是一间专业的医疗化验所，专注基因检测及普及基因检测的应用，尤其生育及亲子健康方面。 ",
  MissionDetail21: "2018年，香港卓信医疗化验所成功通过BSI英国标准协会的审核，荣获ISO 9001:2015国际质量认证。",
  MissionDetail22: "于2020/21年获香港社会服务联会颁发“商界展关怀”殊荣。",
  MissionDetail23: "2019年，香港卓信医疗化验所有限公司成功自创品牌genecode，为顾客带来更全面、更准确的天赋基因检测。 ",
  MissionDetail24: "公司地址",
  MissionDetail25: "香港新界火炭坳背灣街2-12號威力工業中心9樓S室",
},

  Technology: {
    Title: "Technology",
    P1Title: "We deeply understand the importance of accuracy",
    P1Detail: "Every test is the effort of professional team",

    P2_1Title: "Scientists with PhD or master qualification",
    P2_1Detail: "Utilize the latest technology to develop and validate genetic tests that meet international standards",
    P2_2Title: "Registered Medical Laboratory Technologist (Part I)",
    P2_2Detail: "Registered with the Hong Kong Medical Laboratory Technologists Board, oversee the entire test procedures and issue laboratory reports",
    P2_3Title: "Medical Consultant",
    P2_3Detail: "Provide medical advice based on the existing clinical research and guidelines",

    P3Title: "Every sample is analyzed by the most advanced DNA testing equipment",
    P3Detail: "All test reagents are imported from abroad, under strict quality control",

    P4Title: "Strong collaboration with world-renowned laboratories",
    P4_1Detail: "Mayo Clinic Laboratories",
    P4_2Detail: "Natera",
    P4_3Detail: "Lucence Diagnostics",
  },
  Accreditation: {
    Title: "Accreditation & Recognition",
    P1Title: "Recognized medical laboratory in Hong Kong",
    P1Detail: "Supervised by Medical Laboratory Technologists Board",
    P1Button: "See Full List",

    P2Title: "One of a few ISO-accredited laboratories ",
    P2Titles: "in Hong Kong",
    P2Detail: "International accreditation is one of the important benchmarks for any medical laboratory industry. First Choice (Hong Kong) Medical Laboratory has successfully attained the international quality accreditation ISO 9001:2015 to provide high-quality services. Our quality management met up with the most stringent standard of the BSI Royal Charter and most importantly the international standard.",
    P2Detail2: "First Choice (Hong Kong) Medical Laboratory has been striving to establish a quality management system that is specialized, professionalized, standardized, and in line with international standards, to enhance the quality of our medical testing services. The company ISO 9001:2015 quality management certificate is proof of our commitment to providing quality service.",

    P3Title: "About ISO 9001",
    P3Title2: "International Organization for Standardization (ISO)",
    P3Detail: "ISO 9001 is a set of internationally-used quality management tools. Standards are formulated by a group of experts in technical committees to maintain the quality of products and services provided by enterprises and ensure consistent quality. The technical committee is composed of representatives from industry, NGOs, governments and other stakeholders, and members are proposed by ISO members. Obtaining ISO 9001 certification signifies that the organizations have passed strict corporate system audits and reached internationally recognized standards.",
    P3Detail2: "The newly revised ISO 9001:2015 introduces the concept of risk management, focuses on operational risk and performance management. It is to enhance the advantage of our company to fight against the rapidly evolving environment and assists the company to cope with customers' ever-changing needs.",

    P4Title: "Awarded Caring Company Certification",
    P4Detail: "In 2020, First Choice (Hong Kong) Medical Laboratory was awarded the Caring Company Certificate by the Hong Kong Council of Social Service. First Choice (Hong Kong) Medical Laboratory will continue to partner with social service organizations to promote social innovation and solve social problems and try our best to perform social responsibilities.",

    P5Title: "Green office award",
    P5Detail: "Awarded the “Green Office Award Scheme”by the World Green Organization To fulfill our corporate social responsibility, we aimed at reducing the impact of our work on the environment through improving our daily work processes such as recycling plasticware, actively practice the concept of sustainable development by modifying our habits such as using recyclable cutleries. We promise to continually protect the sustainability of our planet.",
  },
  Media: {
    Title: "Media",
    P1Title: "Accurate genetic tests x Professional medical services",
    P1_1Detail: "Uphold brand value",
    P1_1Detail2: "Provide reliable reports",
    P1_1Button: "Report",

    P1_2Detail: "Offer prestigious tests",
    P1_2Detail2: "Latest industry information",
    P1_2Button: "Gene Blog",

    P1_3Detail: "Green work environment",
    P1_3Detail2: "Assume corporate responsibility",
    P1_3Button: "Award Certificate",

    P1_4Detail: "Utilize advanced equipment",
    P1_4Detail2: "Experienced technologist",
    P1_4Button: "Technology",

    P1_5Detail: "Hundreds of samples",
    P1_5Detail2: "Strict quality control",
    P1_5Button: "Accreditation",

    P1_6Detail: "Touch business insights",
    P1_6Detail2: "Invite win-win collaboration",
    P1_6Button: "Partnership",
  },
  Partnership: {
    Title: "Partnership",
    P1Title: "According to the Medical Laboratory Technologist《Code of Practice》Part II Section 6(c):",
    P1Detail: "All medical laboratory technologist should NOT perform any tests for the purpose of medical diagnosis and treatment in the absence of a referral from registered medical, dental and/or veterinary practitioners, or a person registered in respect of a medical clinic exempted under Section 8(1) of the Medical Clinics Ordinance, Cap. 343.",
    P1Detail2: "First Choice (Hong Kong) Medical Laboratory only performs tests on samples referred by medical doctors. If you require any information, please do not hesitate to contact us at (+852) 2865 9399.",
  },
  Career: {
    Title: "Career",
    P1Title: "Want to join medical laboratory industry?",
    P1Title2: "Responsibility:",
    P1Title3: "Qualification:",
    P2Detail: "To apply for the above vacancies, please email your CV to hr@hkfirstchoice.com",
    P2Detail2: "（Please specific the position）",
  },

  Cancerrealtime: {
    CancerReal_one: "Early detection of cancer recurrence, grasp the golden period of treatment",
    CancerReal_two: "New ctDNA technology keeps tracking of tumor",
    CancerReal_three: "What is ctDNA?",
    CancerReal_four: "Circulating Tumor DNA (ctDNA) is the DNA fragment released into the bloodstream by cancer cells after they died. ctDNA carries important information of cancer gene mutation.",
    CancerReal_five: "By monitoring the dynamic changes of ctDNA in blood, it can reflect the status of the tumor in the patient's body and detect early signs of cancer recurrence.",
    CancerReal_six: "Detect Recurrences Earlier than Conventional Methods",
    CancerReal_seven: "LiquidHALLMARK",
    CancerReal_f: " Cancer Monitoring",
    CancerReal_eight: "The world's first blood test that simultaneously detects cancer gene mutations and cancer-causing viruses using ctDNA technology.",
    CancerReal_nine: "Support by patented AmpliMARK™ technology, which can detect tiny amounts of ctDNA. ",
    CancerReal_ten: "Passed clinical validation in guiding treatment decision for the oncologists.",
    CancerReal_eleven: "50 cancer genes",
    CancerReal_twelve: "Include multiple actionable genes, such as EGFR (Gefitinib, Osimertinib) and ALK (Crizotinib)",
    CancerReal_threeteen: "6 microsatellite instability markers",
    CancerReal_fourteen: "Predict if immunotherapy is efficacious",
    CancerReal_fiveteen: "2 cancer-causing viruses",
    CancerReal_sixteen: "Hepatitis B virus (HBV) and Epstein-Barr virus (EBV)",
    CancerReal_seventeen: "4 genetic variations",
    CancerReal_eighteen: "Single Nucleotide Variant (SNV), Small Insertion/Deletion (Indel), Gene Amplification, Gene Fusion",
    CancerReal_nineteen: "Monitor 14 Cancer Types in One Blood Draw",
    CancerReal_twenty: "Lung Cancer",
    CancerReal_twenty_one: "12 genes",
    CancerReal_twenty_two: "Breast Cancer",
    CancerReal_twenty_three: "9 genes",
    CancerReal_twenty_four: "Colon Cancer",
    CancerReal_twenty_five: "11 genes",
    CancerReal_twenty_six: "Liver Cancer",
    CancerReal_twenty_seven: "14 genes + HBV",
    CancerReal_twenty_eight: "Nasopharyngeal Cancer",
    CancerReal_twenty_nine: "7 genes + EBV",
    CancerReal_thirty: "Bile Duct Cancer",
    CancerReal_thirty_one: "19 genes",
    CancerReal_thirty_two: "Esophageal Cancer",
    CancerReal_thirty_three: "13 genes",
    CancerReal_thirty_four: "Gastrointestinal Stromal Tumor",
    CancerReal_thirty_five: "7 genes",
    CancerReal_thirty_six: "Blood Cancer (including Myeloma)",
    CancerReal_thirty_eight: "10 genes",
    CancerReal_thirty_nine: "Head & Neck Cancer",
    CancerReal_fourty: "8 genes",
    CancerReal_fourty_one: "Melanoma",
    CancerReal_fourty_two: "14 genes",
    CancerReal_fourty_four: "Pancreatic Cancer",
    CancerReal_fourty_five: "8 genes",
    CancerReal_fourty_six: "Bladder Cancer",
    CancerReal_fourty_seven: "8 genes",
    CancerReal_fourty_eight: "Prostate Cancer",
    CancerReal_fourty_nine: "6 genes",
    CancerReal_fifty: "LiquidMARK",
    CancerReal_fifty_one: " can be used to monitor specific cancer type on a regular basis.",
    CancerReal_fifty_two: "All the above tests include testing of 6 microsatellite instability (MSI) markers.",
    CancerReal_fifty_three: "LiquidHALLMARK",
    CancerReal_fuhao: "®",
    CancerReal_canhelp: " Can Help You",
    CancerReal_fifty_four: "Guide treatment decision",
    CancerReal_fifty_five: "Due to old age or a hidden location of tumor, traditional tissue biopsy cannot be performed in some cancer patients",
    CancerReal_fifty_six: "ctDNA can help provide guidance on drug use for patients whose tumor tissue cannot be obtained by surgery or needle biopsy.",
    CancerReal_fifty_seven: "Evaluate Treatment Efficacy",
    CancerReal_fifty_eight: "Studies have shown that if the treatment is effective, the amount of ctDNA detected will significantly decrease",
    CancerReal_fifty_nine: "The prognosis of patient is better if ctDNA cannot be detected in the blood after tumor resection.",
    CancerReal_sixty: "If ctDNA can be detected, the prognosis is relatively poor and the chance of recurrence is higher.",
    CancerReal_sixty_one: "Monitor Cancer Recurrence",
    CancerReal_sixty_two: "Study has shown that changes in ctDNA can be detected 5.2 months earlier than radiological imaging",
    CancerReal_sixty_three: "ctDNA can detect early signs of recurrence. It can help oncologist adjust treatment plans early through intensive monitoring",
    CancerReal_sixty_four: "Track Drug Resistance",
    CancerReal_sixty_five: "Treatment efficacy is lost after the prolonged use of a certain drug. This is because mutation in a specific gene can lead to drug resistance",
    CancerReal_sixty_six: "The detection of ctDNA mutation can help understand drug resistance mechanism and adjust treatment strategy accordingly.",
    CancerReal_sixty_seven: "Target Group",
    CancerReal_sixty_eight: "FAQ",
    CancerReal_sixty_nine: "Is LiquidHALLMARK",
    CancerReal_sixty_nine_end: " suitable for early cancer screening in healthy individual?",
    CancerReal_seventy: "Not applicable. This test is suitable for patients with confirmed cancer who require real-time monitoring of tumor, as well as early detection of cancer recurrence.",
    CancerReal_seventy_one: "Do I need to be tested multiple times?",
    CancerReal_seventy_two: "This test can provide close attention and is recommended for regular testing every 6-12 months. The frequency of testing depends on the stage of your cancer and your treatment process. ",
    CancerReal_seventy_three: "What is the significance of testing microsatellite instability (MSI)?",
    CancerReal_seventy_four: "Microsatellite instability (MSI) can be used to predict the outcome of immunotherapy, to help patients decide whether or not immunotherapy is appropriate, and to avoid costly treatments or the missing of golden treatment window.",
    CancerReal_seventy_five: "References:",

  },

  Genetictumordetection: {
    Genetictumordetection_one: "Cancer genes can be inherited",
    Genetictumordetection_two: "Early detection in high-risk populations, prevention is better than cure",
    Genetictumordetection_three: "Genetic Mutations in Tumors Dramatically Increase Cancer Risk",
    Genetictumordetection_four: "According to statistics, there are about 17.5 million new cancer cases and 8.7 million cancer-associated deaths in the world each year. About 5-10% of cancer cases are caused by genetic mutations. Common BRCA1/2 mutations significantly increase the risk of breast cancer, ovarian cancer1,2, colorectal cancer3, and gastric cancer4.",
    Genetictumordetection_five: "Report issued by registered Medical Laboratory Technologist(Part I).",
    Genetictumordetection_fives: 'Has your family ever had cancer?',
    Geneticitumordetection_fishes: "Has your family ever had cancer?",
    Genetictumordetection_six: "Have you ever had cancer before the age of 50?",
    Genetictumordetection_seven: "FCRisk™ Hereditary Cancer Screening",
    Genetictumordetection_eight: "Provide detailed genetic information, which help doctors assess the risk of related cancers.",
    Genetictumordetection_nine: "Provide the basis for treatment and health management. High-risk individual can take preventive measures as early as possible.",
    Genetictumordetection_ten: "Provide two packages for different genders. The male package tests 79 genes for 16 cancer types; the female package tests 74 genes for 17 cancer types.",
    Genetictumordetection_eleven: "Male Package",
    Genetictumordetection_twelve: "Hereditary Cancer",
    Genetictumordetection_threeteen: "Female Package",
    Genetictumordetection_fourteen: "Prostate Cancer",
    Genetictumordetection_fiveteen: " Breast Cance",
    Genetictumordetection_sixteen: "Ovarian Cancer",
    Genetictumordetection_seventeen: "Endometrial Cancer",
    Genetictumordetection_eighteen: "Colorectal Cancer",
    Genetictumordetection_nineteen: "Gastric Cancer",
    Genetictumordetection_twenty: "Renal Cancer",
    Genetictumordetection_twenty_one: "Renal Cancer",
    Genetictumordetection_twenty_two: "Thyroid Cancer",
    Genetictumordetection_twenty_three: "Parathyroid Cancer ",
    Genetictumordetection_twenty_four: " Neurofibromatosis",
    Genetictumordetection_twenty_five: "Pheochromocytoma ",
    Genetictumordetection_twenty_six: "Familial Paraganglioma",
    Genetictumordetection_twenty_seven: "Retinoblastoma",
    Genetictumordetection_twenty_eight: "Melanoma",
    Genetictumordetection_twenty_nine: "Chondrosarcoma",
    Genetictumordetection_thirty: "Pancreatic Cancer ",
    Genetictumordetection_thirty_one: "Gastrointestinal Stromal Tumor",
    Genetictumordetection_thirty_two: "Target Group",
    Genetictumordetection_thirty_three: "Has a family history of cancer",
    Genetictumordetection_thirty_four: "Has a family history of cancer and is suffering from cancer",
    Genetictumordetection_thirty_five: "Cancer patients diagnosed before 50 years old and have no family history of cancer",
    Genetictumordetection_thirty_six: "Healthy people who is concerned about genetic mutations",
    Genetictumordetection_thirty_eight: "Advantages",
    Genetictumordetection_thirty_nine: "Comprehensive Screening",
    Genetictumordetection_fourty: "Test only once in a lifetime",
    Genetictumordetection_fourty_one: "Precise",
    Genetictumordetection_fourty_two: "Sequencing accuracy is up to 99.9%, supported by large database",
    Genetictumordetection_fourty_three: "Exclusive Advice",
    Genetictumordetection_fourty_four: "Report explained by a professional genetic counselor",
    Genetictumordetection_fourty_five: "Safe and Trustworthy",
    Genetictumordetection_fourty_six: "Simple blood draw to minimize the damage",
    Genetictumordetection_fourty_seven: "Test Procedure",
    Genetictumordetection_fourty_eight: "1. Pre-test Consultation",
    Genetictumordetection_fourty_nine: "Choose a test package that suits you most.",
    Genetictumordetection_fifty: "2. Sample Collection",
    Genetictumordetection_fifty_one: "Take blood samples in the clinic and send to the laboratory for testing.",
    Genetictumordetection_fifty_two: "3. Genetic Sequencing Analysis",
    Genetictumordetection_fifty_three: "Complete the sequencing and analysis according to a rigorous experimental procedure.",
    Genetictumordetection_fifty_four: "4. Issue Report",
    Genetictumordetection_fifty_five: "Report is reviewed and issued by Medical Laboratory Technologist (Part I).",
    Genetictumordetection_fifty_six: "5. Interpret Report",
    Genetictumordetection_fifty_seven: "Interpret reports and manage cancer risks.",
    Genetictumordetection_fifty_eight: "參考文獻",
    Genetictumordetection_fifty_nine: 'According to statistics,there are about',
    Genetictumordetection_sixty: '17.5 million new cancer cases',
    Genetictumordetection_sixty_one: ',and 8.7 million cancer-associated deaths in the world each year.',
    Genetictumordetection_sixty_two: 'About 5-10% of cancer cases are caused by genetic mutations. ',
    Genetictumordetection_sixty_three: 'Common BRCA1/2 mutations significantly increase the risk of breast cancer',
    Genetictumordetection_sixty_four: 'ovarian cancer',
    Genetictumordetection_sixty_five: 'colorectal cancer',
    Genetictumordetection_sixty_six: 'and gastric cancer',

  },

  Talentgenetesting: {
    Talentgenetesting_one: "Understand your children's talent and aptitude",
    Talentgenetesting_two: "Tailor-made child-rearing suggestions based on genetics",
    Talentgenetesting_three: "We Born Different Because of Varying Genetic Codes",
    Talentgenetesting_four: "Each child is unique and receives special talents from parents.",
    Talentgenetesting_five: "Differences among people are determined by genes. The most common genetic change us caused by a single nucleotide in the DNA sequence, namely single nucleotide polymorphism (SNP).",
    Talentgenetesting_six: "In addition to visible phenotypes such as pupil color, our intrinsic potential, personality, intelligence, and nutritional needs are all determined by SNP to some extent.",
    Talentgenetesting_seven: "How to Predict Children's Talent?",
    Talentgenetesting_eight: "With the completion of the human genome sequencing program and the development of gene chips and next-generation sequencing technologies, we are now able to analyze our whole genome.",
    Talentgenetesting_nine: "Through large-scale genome-wide association study (GWAS), researchers have identified SNPs that are associated with talent.",
    Talentgenetesting_ten: "genecode Talent Gene Test",
    Talentgenetesting_eleven: "Comprehensive test based on genomic analysis",
    Talentgenetesting_twelve: "Cover 5 important categories: Talent, IQ, EQ, Nutrition, and Fitness",
    Talentgenetesting_threeteen: "Next-generation sequencing technology with 99.9% accuracy in genotyping",
    Talentgenetesting_fourteen: "Focus on Asian data from 7 major genomic databases",
    Talentgenetesting_fiveteen: "Non-invasive sampling, safe and painless, simple and fast",
    Talentgenetesting_sixteen: "Test Items",
    Talentgenetesting_seventeen: "Combination of 5 Growth Factors (70 items)",
    Talentgenetesting_eighteen: "Talent Code – 6 items",
    Talentgenetesting_nineteen: "6 Talents:",
    Talentgenetesting_nineteens: "Language, Music, Mathematics, Reading, Painting, Sports talents",
    Talentgenetesting_twenty: "EQ Code – 14 items",
    Talentgenetesting_twenty_one: "5 Personalities: Amorous, Introverted, Impulsive, Easygoing, Highly Sensitive",
    Talentgenetesting_twenty_two: "4 Abilities:",
    Talentgenetesting_twenty_twos: "Persistence, Attention, Leadership, Resistance to Stress",
    Talentgenetesting_twenty_three: "3 Aspirations:",
    Talentgenetesting_twenty_threes: "Responsibility, Curiosity, Empathy",
    Talentgenetesting_twenty_four: "2 Tendencies:",
    Talentgenetesting_twenty_fours: "Anxiety, Reward Dependence",
    Talentgenetesting_twenty_five: "IQ Code – 14 items",
    Talentgenetesting_twenty_six: "8 Memories: ",
    Talentgenetesting_twenty_sixs: "Logical, Visual, Spatial, Long-term, Short-term, Working, Episodic, Speech Memories",
    Talentgenetesting_twenty_seven: "3 Intelligences:",
    Talentgenetesting_twenty_sevens: "Crystal IQ, Fluid IQ, Operation IQ",
    Talentgenetesting_twenty_eight: "3 Abilities:",
    Talentgenetesting_twenty_eights: "Error Avoidance, Cognitive Ability, Reasoning Ability",
    Talentgenetesting_twenty_nine: "Nutrition & Health Code – 26 items",
    Talentgenetesting_thirty: "8 Vitamin Levels:",
    Talentgenetesting_thirtys: "Folic Acid, Vitamin A, Vitamin B6, Vitamin B12, Vitamin C, Vitamin D and Calcium, Vitamin E, Vitamin K1",
    Talentgenetesting_thirty_one: "6 Trace Element Levels: Zinc, Lead, Selenium, Copper, Iron, Magnesium ",
    Talentgenetesting_thirty_two: "2 Nutritional Needs: Omega 3, Antioxidant ",
    Talentgenetesting_thirty_three: "10 Health Risks: Alcohol Dependence, Coffee Tolerance, Freckles risk, Acne risk, High Myopia, Periodontitis, Allergic Rhinitis, Susceptibility to Tanning, Lactose Metabolic Capacity, Atopic Eczema",
    Talentgenetesting_thirty_four: "Fitness Code – 10 items",
    Talentgenetesting_thirty_five: "10 Physical Traits:",
    Talentgenetesting_thirty_fives: "Explosive Power, Endurance, Bone Strength, Risk of Sports Injury, Lung Function, Exercise Weight Loss Effect, Height, Shaping Effect of Strength Training, Sweet Taste Preference, Effects of Saturated Fatty Acids on Obesity",
    Talentgenetesting_thirty_six: "Scientific Research from Prestigious Academic Institutions",
    Talentgenetesting_thirty_seven: "Harvard Medical School",
    Talentgenetesting_thirty_eight: "Height",
    Talentgenetesting_thirty_nine: "Yale University",
    Talentgenetesting_fourty: "Explosive Power",
    Talentgenetesting_fourty_one: "University of Oxford",
    Talentgenetesting_fourty_two: "Speech Memory",
    Talentgenetesting_fourty_three: "King's College London",
    Talentgenetesting_fourty_four: "Mathematics Talent",
    Talentgenetesting_fourty_five: "University of California Los Angeles",
    Talentgenetesting_fourty_six: "Persistence",
    Talentgenetesting_fourty_seven: "University College London",
    Talentgenetesting_fourty_eight: "Leadership",
    Talentgenetesting_fourty_nine: "The Formula for Success",
    Talentgenetesting_fifty: "genecode Talent Gene Test helps you analyze the effects of genes on 5 main aspects of your potential and traits, namely talent, IQ, EQ, nutrition and fitness.",
    Talentgenetesting_fifty_one: "Educate by aptitude",
    Talentgenetesting_fifty_two: "Explore talents and educate in a proper way",
    Talentgenetesting_fifty_three: "Emotional management",
    Talentgenetesting_fifty_four: "Grasp personality and improve parent-child relationships",
    Talentgenetesting_fifty_five: "Improve efficiency",
    Talentgenetesting_fifty_six: "Find the right way to learn and remember",
    Talentgenetesting_fifty_seven: "Protect health",
    Talentgenetesting_fifty_eight: "Understand nutritional and metabolic needs",
    Talentgenetesting_fifty_nine: "Make good use of time",
    Talentgenetesting_sixty: "Develop a suitable exercise program for children",
    Talentgenetesting_sixty_one: "Oral sampling",
    Talentgenetesting_sixty_two: "Safe and painless",
    Talentgenetesting_sixty_three: "Watch Vedio",
    Talentgenetesting_sixty_four: "Professional Counselling",
    Talentgenetesting_sixty_five: "Bespoke follow-up advice",
    Talentgenetesting_sixty_six: "Baby's photo printed",
    Talentgenetesting_sixty_seven: "Best gift for children",
    Talentgenetesting_sixty_eight: "Parent Voice",
    Talentgenetesting_sixty_nine: "Target Group",
    Talentgenetesting_seventy: "Children of 0-12",
    Talentgenetesting_seventys: "years old",
    Talentgenetesting_seventy_one: "People who care about nutrition, diet and health",
    Talentgenetesting_seventy_two: "Sports and fitness enthusiasts",
    Talentgenetesting_seventy_three: "People at risk for familial genetic diseases",
    Talentgenetesting_seventy_four: "Genecode and Their Story",
    Talentgenetesting_seventy_five: "4 years old speaker",
    Talentgenetesting_seventy_six: "June is an outgoing little girl who never fears a new social environment. At the age of 3, June moved to Hong Kong with her parents, who are lawyers. She had never spoken Cantonese but was able to answer questions in 3 months. Her parents were very curious about her language talent. The genecode results indeed showed that June does have a strong language talent. It is worth noting that June's attention and persistence are relatively poor, so her parents should focus on this for better development.",
    Talentgenetesting_seventy_seven: "June's story",
    Talentgenetesting_seventy_eight: "3 years old sportsman",
    Talentgenetesting_seventy_nine: "After completing the genecode Talent Code test, it showed that Charlotte is really talented in sports. There are many types of sports, and Charlotte is only 3 years old, so she cannot choose a suitable sport. Her parents immediately took Charlotte to perform genecode Fitness Code as well as Nutrition & Health Code tests. The report revealed that Charlotte has excellent lung function and endurance, so she is suitable for long-distance running and swimming. However, Charlotte tends to get tanned easily, so sun protection is needed to protect her skin.",
    Talentgenetesting_eighty: "Charlotte's story",
    Talentgenetesting_eighty_one: "8 years old talented reader",
    Talentgenetesting_eighty_two: "Jacob is introverted and doesn't like talking. The problem most worried by his parents was that Jacob's memory seemed to be weaker than that of his peers. He often forgot what his parents or teachers told him. Jacob's mom hopes to learn more about his personality and memory through genecode. However, the result surprised Jacob's mom. It showed that Jacob was not an introvert and had a great reading talent. It's only that Jacob's voice memory is relatively weak, so he can't remember his parents' instructions and doesn't like talking.",
    Talentgenetesting_eighty_three: "Jacob's story",
    Talentgenetesting_eighty_four: "FAQ",

    Talentgenetesting_eighty_five: "How to test your baby's talent through genes?",

    Talentgenetesting_eighty_six: "How is talent gene test performed? Is the process safe?",

    Talentgenetesting_eighty_seven: "Is talent gene test accurate? Why are there reports saying that it is not reliable?",

    Talentgenetesting_eighty_eight: "What is the relationship between inborn talents and parenting?",

    Talentgenetesting_eighty_nine: "How does talent gene test help parents raise their children?",

    Talentgenetesting_ninety: "References:",
  },
  YChromosomeDNATest: {
    Title: "Y-Chromosome DNA Test",
    // P1Title: "Know your baby gender in early pregnancy",
    P1Title: "Y chromosome maternal blood test was performed in early pregnancy",
    P1Detail: "Intervene genetic diseases in time",

    P2Title: "Fetal DNA Exists in Mother's Blood",
    P2Detail: "During pregnancy, the cell-free fetal DNA (cffDNA) can circulate into mother's bloodstream through placenta.",
    P2Detail2: "At 6-7 weeks of pregnancy, the cffDNA amount in the mother's blood has made it possible to identify Y chromosome sequences.",

    // P3Title: "Sex chromosome XY = Male",
    // P3Title2: "Sex chromosome XX = Female",
    P3Title: "",
    P3Title2: "",

    // oldP4Title: "Why do We Need to Know Fetal Sex Early?",
    P4Title: "What is X-linked Recessive Disease?",
    // P4Detail: "Early prenatal diagnosis of fetal sex is necessary to optimize pregnancy management in ",
    // P4Detail_2: "families at risk for genetic disorders.",
    // P4Detail_3: "",
    // P4Detail2: "For example, X-linked recessive diseases (such as ",
    P4Detail: "",
    P4Detail_2: "",
    P4Detail_3: "",
    P4Detail2: "X-linked recessive diseases (such as ",
    P4Detail2_2: "Fragile X Syndrome",
    P4Detail2_3: ") are severe hereditary diseases that are manifested solely in males. If the mother is a carrier of an X-linked recessive disease, she can have a boy that becomes ill with the X-linked disease.",
    // P4Detail3: "That's why it is important to conduct prenatal genetic counseling and know your fetal sex earlier.",
    P4Detail3: "Therefore, detailed prenatal genetic counseling is very necessary.",

    P5Title: "How to Perform the Y-Chromosome DNA Test?",
    P5Detail: "Extract cell-free fetal DNA from mother's blood sample.",
    P5Detail2: "Use specific primer to detect Y chromosome DNA.",
    P5Detail3: "If Y chromosome DNA is present, the target sequence will be amplified until it is detected by fluorescent signal.",


    P6Title: "How to Perform the Y-Chromosome DNA Test?",
    P6Row1Col1: "Test", P6Row1Col2: "Turnaround Time", P6Row1Col3: "Sample Requirements",
    P6Row2Col1: "Maternal Serum Screening Test ≥7 weeks", P6Row2Col2: "1 Working Day", P6Row2Col3: "6mL EDTA Maternal Blood x2",
    P6Row3Col1: "Maternal Serum Screening Test ≥7 weeks (URGENT)", P6Row3Col2: "6 Hours", P6Row3Col3: "6mL EDTA Maternal Blood x2",
    P6Row4Col1: "Maternal Serum Screening Test ≥6 weeks", P6Row4Col2: "1 Working Day", P6Row4Col3: "6mL EDTA Maternal Blood x2",
    P6Row5Col1: "Maternal Serum Screening Test ≥6 weeks (URGENT)", P6Row5Col2: "6 Hours", P6Row5Col3: "6mL EDTA Maternal Blood x2",

    P7Title: "Advantages",
    P7_1Title: "Accurate",
    P7_1Detail: "Up to 99.9% accuracy",
    P7_2Title: "Early",
    P7_2Detail: "Test as early as 6 weeks of pregnancy",
    P7_3Title: "Fast",
    P7_3Detail: "Get report in 6 hours",
    P7_4Title: "Confident",
    P7_4Detail: "Under surveillance of Medical Laboratory Technologists Board",
    P7_5Title: "Advanced Technology",
    P7_5Detail: "Precise and automatic DNA detection technology",
    P7_6Title: "Safe",
    P7_6Detail: "No risk of miscarriage",

    P8Title: "Target Group",
    P8_1Detail: "Pregnant women",
    P8_1Details: "(≥6 weeks pregnancy)",
    P8_2Detail: "Pregnant women with family history of genetic disease (gender-related)",

  },
  NonInvasivePrenatalTest: {
    Title: "Non-invasive Prenatal Test",
    P1Title: "First choice for pregnant women to protect baby health",
    P1Detail: "Beware of chromosomal abnormalities to reduce risk of genetic diseases",

    P2Title: "Are You Aware of Chromosomal Diseases?",
    P2Detail: "Every normal human has 23 pairs of chromosomes, 22 pairs are autosomal chromosomes, and one pair is sex chromosomes which determine sex.",
    P2Detail2: "When the number or structure of chromosomes is abnormal, for example, if one of the chromosome pairs has three copies, chromosomal diseases will happen.",
    P2Detail3: "Most chromosomal diseases are due to random mutation during the formation of fertilized eggs. Therefore, ",
    P2Detail3_2: "any parents may give birth to a child with a chromosomal disease.",
    P2Detail4: "Current, chromosomal diseases are incurable. Therefore it is important to choose a safe, fast, and accurate prenatal test in preparation of the baby arrival.",

    P3Title: "Typical Syndromes of Chromosomal Diseases:",
    P3_1Title: "Mental Retardation",
    P3_2Title: "Autism",
    P3_3Title: "Growth Delay",
    P3_4Title: "Deformity",
    P3_5Title: "Congenital Heart Disease",

    P4PreTitle: "Expecting a baby?",
    P4Title: "Non-invasive Prenatal Test",
    P4Detail: "Provides the strongest support for the expectant mothers",

    P5Title: "What Is Non-invasive Prenatal Test?",
    P5Detail: "Non-invasive prenatal test (NIPT) is a safe, simple, non-invasive prenatal test that can screen for specific chromosomal diseases from the 9 weeks of pregnancy.",
    P5Detail2: "During pregnancy, the fetal DNA passes through the placenta and enters the mother's circulatory system. Using peripheral blood from pregnant women, NIPT utilizes the next-generation sequencing technology to screen for chromosomal abnormalities in the fetus.",


    P6Title: "Comparison of Prenatal Tests",
    P6Detail: "Compared with traditional invasive prenatal diagnostic methods (e.g. amniocentesis), NIPT is a safe method of prenatal testing, which will not cause miscarriage nor infection. This greatly reduces the fear of prenatal testing in pregnant women, hence increasing their willingness to be screened for prenatal chromosomal abnormalities",
    P6Row1Col1: "",
    P6Row1Col2: "NIPT",
    P6Row1Col3: "Early pregnancy screening",
    P6Row1Col4: "Mid-pregnancy screening",
    P6Row1Col5: "Amniocentesis",
    P6Row2Col1: "Pregnancy Week",
    P6Row2Col2: "≥ 9 weeks",
    P6Row2Col3: "11-13 weeks",
    P6Row2Col4: "16-19 weeks",
    P6Row2Col5: "16-20 weeks",
    P6Row3Col1: "Method",
    P6Row3Col2: "Analysis of cell-free fetus DNA from placenta",
    P6Row3Col3: "Ultrasound measurement of fetal neck skin. Maternal blood test (PAPP-A, hCG)",
    P6Row3Col4: "Maternal blood test (AFP, hCG,uE3 and Inhibin A)",
    P6Row3Col5: "Fetal chromosome analysis",
    P6Row4Col1: "Detection Rate",
    P6Row4Col2: "≥ 99%",
    P6Row4Col3: "80-90%",
    P6Row4Col4: "80%",
    P6Row4Col5: "≥ 99%",
    P6Row5Col1: "Invasiveness",
    P6Row5Col2: "Non-invasive(Maternal blood drawn with no risk of miscarriage or infection)",
    P6Row5Col3: "Non-invasive(Maternal blood drawn with no risk of miscarriage or infection)",
    P6Row5Col4: "Non-invasive(Maternal blood drawn with no risk of miscarriage or infection)",
    P6Row5Col5: "Invasive(0.5% -1% risk of miscarriage or infection when taking amniotic fluid)",
    P6Row6Col1: "Turnaround Time",
    P6Row6Col2: "As early as 3 working days",
    P6Row6Col3: "1-2 working days",
    P6Row6Col4: "1-2 working days",
    P6Row6Col5: "14-21 working days",


    P7Title: "Target Group",
    P7_1Detail: "Pregnant Women (≥9 weeks pregnancy)",
    P7_2Detail: "Mother who is not willing to receive invasive sample collection",
    P7_3Detail: "Pregnant women with high risk result for Down Syndrome",
    P7_4Detail: "Pregnant women with history of miscarriage ",
    P7_4Details: "or IVF baby",
    P7_5Detail: "Pregnant women with history of chromosome abnormality",

    P8Title: "Advantages",
    P8_1Title: "Safe",
    P8_1Detail: "No risk of miscarriage",
    P8_2Title: "Easy and Fast",
    P8_2Detail: "Use maternal blood, get results in 3-7 working days",
    P8_3Title: "Confident",
    P8_3Detail: "Report issued by registered Medical Laboratory Technologist",
    P8_4Title: "Early",
    P8_4Detail: "Test as early as 9 weeks of pregnancy (including twins)",
    P8_5Title: "Comprehensive",
    P8_5Detail: "Trisomy, Sex Chromosome Abnormality, Microdeletion and Microduplication",

    P9Title: "FAQ",
    P9_1Title: "Are pregnant women under 35 suitable for NIPT?",
    P9_1Detail: "Suitable. NIPT screens for trisomy, sex chromosomal abnormality, and microdeletion and microduplication.",
    P9_1Detail2: "Although Down syndrome, one of the trisomy syndromes, is more common in pregnant women over 35 years age, the incidence of microdeletion and microduplication syndrome does not increase with age. Microdeletion and microduplication syndrome can happen in all babies regardless of the pregnancy age. Therefore, NIPT is necessary even for pregnant women under 35 years age.",
    P9_2Title: "Does a low-risk NIPT result mean that amniocentesis is not required?",
    P9_2Detail: "No. Although NIPT is highly accurate, its result is only used for screening purposes but not for final diagnosis. At present, karyotyping analysis is still the gold standard for prenatal diagnosis.",
    P9_2Detail2: "Therefore, if the test result is low-risk, the possibility of fetal disease cannot be completely ruled out. Whether an amniocentesis is required is subjected to the doctor's instructions.",
  },
  NonInvasivePrenatalPaternityTest: {
    Title: "Non-invasive Prenatal Paternity Test",
    P1Title: "Can paternity test be done before the baby is born?",
    P1Detail: "YES!",

    P2Title: "What is Non-invasive Prenatal Paternity Test?",
    P2Detail: "Non-invasive prenatal paternity test compares the child's DNA extracted from mother's blood with the DNA profile of the alleged father based on SNP genotyping.",
    P2Detail2: "Since cell-free fetal DNA (cffDNA) in plasma is fragmented, it is hard to obtain sufficient quality cffDNA to determine paternity by traditional technology. The new SNP-based technology is applicable to short DNA fragments, allowing vast number of SNPs across the human genome to be analyzed accurately.",

    P3Title: "Advantages",
    P3_1Title: "Safe",
    P3_1Detail: "Use maternal blood, no risk of miscarriage",
    P3_2Title: "Easy",
    P3_2Detail: "10 mL maternal blood is enough, no need to perform invasive procedures",
    P3_3Title: "Early",
    P3_3Detail: "Test as early as 7 weeks of pregnancy",
    P3_4Title: "Accurate",
    P3_4Detail: "Above 99.999999% accuracy",
    P3_5Title: "Fast",
    P3_5Detail: "Get results within 5 working days",
    P3_6Title: "Private",
    P3_6Detail: "Absolutely confidential, no personal information will be disclosed",

    P4Title: "Type of Samples Accepted",
    P4_1Title: "Pregnant Mother",
    P4_1Detail: "10 mL maternal blood",
    P4_2Title: "Alleged Father",
    P4_2Detail: "Blood, Buccal Swab, Finger Nail, Blood Spot,",
    P4_2Details: "Semen Spot, 5-10 Hairs with Follicles",
    P4_2Detail2: "(Any ONE, blood and buccal swabs are preferred)",

    P5Title: "Target Group",
    P5_1Detail: "Mother who wants to confirm the alleged father of baby",
    P5_2Detail: "Men who want to confirm paternity of baby",
    P5_3Detail: "Mother who is not willing to receive invasive sample collection",
    P5_4Detail: "Mother who is not suitable to have invasive sample collection, e.g. low amniotic fluid",
  },

  vaccinetest: {
    vaccinetest_one: "Understand vaccine protection from infectious diseases",
    vaccinetest_two: "Vaccine is not valid for life, infection can be fatal",
    vaccinetest_three: "What is vaccine? What are antibodies?",
    vaccinetest_four: "Vaccine is a whole or part of a pathogen, which is either inactivated or weakened during the manufacturing process with the addition of a stabilizer and an adjuvant. From an immunological point of view, vaccination is the inoculation of a vaccine into the human body. The immune system recognizes foreign objects, screens and produces antibodies against the pathogen, so that the body gains immunity against that specific pathogen.",
    vaccinetest_five: "Vaccination may not provide lifetime protection because of:",
    vaccinetest_six: "1. Vaccine Protection Rate",
    vaccinetest_seven: '"Vaccine protection rate of 97%" does not mean that one person enjoys 97% protection, but that three out of 100 people may get sick!',
    vaccinetest_eight: "2. Protection Period",
    vaccinetest_nine: "Antibodies level decrease over time. Most vaccines are not guaranteed for life!",
    vaccinetest_ten: "3. Production Quality",
    vaccinetest_eleven: "Some vaccine may not pass quality control. Improper storage and transportation temperature will cause the vaccine to be invalid!",
    vaccinetest_twelve: "4. Health Condition During Vaccination",
    vaccinetest_threeteen: "People have different body status, in which they cannot stimulate the immune system to produce sufficient antibodies!",
    vaccinetest_fourteen: "Test Content",
    vaccinetest_fiveteen: "HAVAb, Total",
    vaccinetest_sixteen: "HBsAb (Quantitative)",
    vaccinetest_seventeen: "Measles Ab IgG",
    vaccinetest_eighteen: "Mumps Ab IgG",
    vaccinetest_nineteen: "Rubella Ab IgG",
    vaccinetest_twenty: "Varicella-Zoster Ab IgG",
    vaccinetest_twenty_one: "Tetanus Toxoid IgG",
    vaccinetest_twenty_two: "Diphtheria Toxoid IgG",
    vaccinetest_twenty_three: "Poliovirus (Types 1, 3) Ab",
    vaccinetest_twenty_four: "Haemophilus Influenzae Type B Ab IgG",
    vaccinetest_twenty_five: "Streptococcus Pneumoniae IgG",
    vaccinetest_twenty_six: "Rabies Vaccine Response END-Point Titer",
    vaccinetest_twenty_seven: "Test Package",
    vaccinetest_twenty_eight: "Target Group",
    vaccinetest_twenty_nine: "Children (3 years old or above)",
    vaccinetest_thirty: "Couples planning or in the early pregnancy",
    vaccinetest_thirty_one: "People who have been vaccinated long ago or are not sure about their vaccination history",
    vaccinetest_thirty_two: "Patients with immune dysfunction",
    vaccinetest_thirty_three: "Travelers going to areas at high risk of infectious disease outbreaks",
    vaccinetest_thirty_four: "Recommendation from The Family Planning Association of HK:",
    vaccinetest_thirty_five: "In case of a negative result in Rubella antibody test before pregnancy, vaccination is recommended to avoid transmission to the fetus which may cause fetal congenital abnormalities. It is recommended to hold off your pregnancy plan for 3 months after vaccination.",
    vaccinetest_thirty_six: "FAQ",
    vaccinetest_thirty_seven: "What should I do if I have received a vaccination but the antibody test result is negative?",
    vaccinetest_thirty_eight: "Different vaccines have different protection rates and protection period. Even vaccinated, some people may still lose their protection over time or due to different immunity. Whether or not a booster shot is needed for a negative antibody test result should be considered based on the doctor's advice and vaccination history.",
    vaccinetest_thirty_nine: "References:",

  },
  stdfastces: {
    stdfastces_one: "Self-testing of sexually transmitted infections (STIs) at home",
    stdfastces_two: "Regular check, worry less",
    stdfastces_three: "staysafe® 4-in-1 STI Rapid Test",
    stdfastces_four: "Screen for FOUR common STIs at ONE time",
    stdfastces_five: "AIDS (HIV)",
    stdfastces_six: "Hepatitis B (HBV)",
    stdfastces_seven: "Syphilis (TP)",
    stdfastces_eight: "Genital Herpes (HSV-2)",
    stdfastces_nine: "Care About You and Your Partner",
    stdfastces_ten: "EASY TO USE",
    stdfastces_eleven: "Only need drops of blood",
    stdfastces_twelve: "YOUR PRIVACY MATTERS",
    stdfastces_threeteen: "Self-test at home, avoid embarrassment",
    stdfastces_fourteen: "RAPID AND ACCURATE",
    stdfastces_fiveteen: "Get result after 15 min",
    stdfastces_sixteen: "How it works?",
    stdfastces_seventeen: "1. Finger-prick to let blood out",
    stdfastces_eighteen: "2. Use pipette to draw blood",
    stdfastces_nineteen: "3. Get result after 15 min",
    stdfastces_twenty: "Learn More",


  },
  news: {
    holiday: "HOLIDAY ARRANGEMENTS",
    specialNotice: "SPECIAL NOTICE",
  },
  monogenicdisease: {
    monogenicdisease_1: "Don't pass defective genes to your baby",
    monogenicdisease_2: "Both couples should be tested before marriage or pregnancy",
    monogenicdisease_3: "What is Monogenic Disease?",
    monogenicdisease_4: "Monogenic disease is a disorder caused by abnormality in a single gene that is passed by parents to a child.",
    monogenicdisease_5: "World Health Organization (WHO) reports that there are over 10,000 of monogenic diseases worldwide",
    monogenicdisease_6: "The prevalence of all monogenic diseases is approximately 1/100, most of them cause death, deformity and disability",
    monogenicdisease_7: "Only 5% of diseases can be managed by medications. Lifelong treatment is expensive and the quality of life is severely affected",
    monogenicdisease_8: "Recessive monogenic disease can occur in families without family history.",
    monogenicdisease_9: "Common Symptoms",
    monogenicdisease_10: "Mental Retardation",
    monogenicdisease_11: "Growth Delay",
    monogenicdisease_12: "Muscle Atrophy",
    monogenicdisease_13: "Organ Failure",
    monogenicdisease_14: "Special Appearance",
    monogenicdisease_15: "Severe Anemia",
    monogenicdisease_16: "Death",
    monogenicdisease_17: "Recessive Monogenic Disease = Silent Killer",
    monogenicdisease_18: "Autosomal Recessive Inheritance",
    monogenicdisease_19: "If both parents are carriers, the child will have",
    monogenicdisease_19s: "25% chance of getting disease.",
    monogenicdisease_20: "X-linked Recessive Inheritance",
    monogenicdisease_21: "If mother is a carrier, the son will have",
    monogenicdisease_21s: "50% chance of getting disease.",
    monogenicdisease_22: "The American College of Obstetricians and Gynecologists recommends",
    monogenicdisease_23: "All pregnant women should screen for monogenic diseases",
    monogenicdisease_24: "Basic Screening: 12 Common Monogenic Diseases",
    monogenicdisease_25: "Autosomal Recessive",
    monogenicdisease_26: "Alpha-thalassemia (HBA1, HBA2)",
    monogenicdisease_27: "Carrier rate: 1/10 (South China)",
    monogenicdisease_28: "Symptoms: Anemia, require regular blood transfusions, may cause death",
    monogenicdisease_29: "Beta-thalassemia (HBB)",
    monogenicdisease_30: "Carrier rate: 1/36 (South China)",
    monogenicdisease_31: "Symptoms: Anemia, require regular blood transfusions, may cause death",
    monogenicdisease_32: "Phenylketonuria (PAH)",
    monogenicdisease_33: "Carrier rate: 1/35",
    monogenicdisease_34: "Symptoms: Intellectual disability, seizures, abnormal behaviors",
    monogenicdisease_35: "Galactosemia (GALT)",
    monogenicdisease_36: "Carrier rate: Unknown",
    monogenicdisease_37: "Symptoms: Developmental and mental retardation, cataract, cirrhosis, may cause death",
    monogenicdisease_38: "Wilson Disease (ATP7B)",
    monogenicdisease_39: "Carrier rate: 1/50",
    monogenicdisease_40: "Symptoms: Liver, nervous system and kidney damage",
    monogenicdisease_41: "Glycogen Storage Disease, Type II (GAA)",
    monogenicdisease_42: "Carrier rate: 1/112",
    monogenicdisease_43: "Symptoms: Damage in multiple tissues and organs, mainly heart, liver, and skeletal muscle",
    monogenicdisease_44: "Spinal Muscular Atrophy (SMN1)",
    monogenicdisease_45: "Carrier rate: 1/62",
    monogenicdisease_46: "Symptoms: Muscles become weak and atrophy",
    monogenicdisease_47: "Hereditary Hearing Loss (GJB2, SLC26A4)",
    monogenicdisease_48: "Carrier rate: 1/29 (GJB2), 1/59 (SLC26A4)",
    monogenicdisease_49: "Symptoms: Hearing loss and deafness",
    monogenicdisease_50: "Cystic Fibrosis (CFTR)",
    monogenicdisease_51: "Carrier rate: Unknown",
    monogenicdisease_52: "Symptoms: Pancreatic dysfunction, lung disease",
    monogenicdisease_53: "X-linked Recessive",
    monogenicdisease_54: "Fragile X Syndrome (FMR1)",
    monogenicdisease_55: "Carrier rate: 1/250-1/1000 (Female)",
    monogenicdisease_56: "Symptoms: Mental retardation, autistic features, emotion problems",
    monogenicdisease_57: "Hemophilia B (F9)",
    monogenicdisease_58: "Carrier rate: Unknown",
    monogenicdisease_59: "Symptoms: Multiple site bleeding, joint deformities",
    monogenicdisease_60: "Duchenne Muscular Dystrophy (DMD)",
    monogenicdisease_61: "Carrier rate: Unknown",

    monogenicdisease_62: "Symptoms: Abnormal gesture, mental retardation",

    monogenicdisease_63: "Comprehensive screening: 101 monogenic diseases",

    monogenicdisease_64: "Retract",

    monogenicdisease_65: "Target Group",

    monogenicdisease_66: "Couples planning or in the early pregnancy",

    monogenicdisease_67: "Couples with family history of genetic disease",

    monogenicdisease_68: "Couples with close degree of consanguinity",

    monogenicdisease_69: "Couples preparing for in-vitro fertilization",

    monogenicdisease_70: "Case Study",

    monogenicdisease_71: " Case: Female from Guangdong, China, 10 weeks pregnant, history of unexplained abortion. ",

    monogenicdisease_72: "Following the doctor's advice, both couples had a genetic test for thalassemia.",

    monogenicdisease_73: "The results showed that ",
    monogenicdisease_s: "both of them are carriers of thalassemia.",


    monogenicdisease_74: "Mrs. Zhang performed an amniocentesis at 18 weeks of pregnancy to analyze her baby's thalassemia gene. The result was (--SEA/αα βN/βN), meaning that the baby does not have severe thalassemia. Therefore, she can continue pregnancy.",

    monogenicdisease_75: "How Does the Test Result Help?",

    monogenicdisease_76: "Negative",

    monogenicdisease_77: "Normal pregnancy plan",

    monogenicdisease_78: "Positive",

    monogenicdisease_79: "It is recommended to adjust the birth plan or choose IVF following genetic counseling",

    monogenicdisease_80: "References:",


  },
  Paternitytesting: {
    paternitytesting_1: "Verify kinship in family, happy ever after",
    paternitytesting_2: "100% confidential",
    paternitytesting_3: "What is Paternity Test?",
    paternitytesting_4: "Paternity is determined by comparing the child's DNA with the DNA profile of the alleged parents.",
    paternitytesting_5: "DNA is dubbed as the genetic “fingerprint” that makes up a person's genes and chromosomes. DNA is unique to everyone, and each parent passes on half of his/her DNA to the baby. Therefore, comparing DNA from the baby and the parents can confirm their paternity.",
    paternitytesting_6: "How Accurate is Paternity Test?",
    paternitytesting_7: "Paternity test is based on Short Tandem Repeat (STR) analysis. By comparing the specific loci of DNA from the child and the parents, we can calculate the Combined Paternity Index (CPI) to determine paternity. ",
    paternitytesting_s: "The accuracy is as high as 99.999999%.",
    paternitytesting_8: "Types of Kinship Determined",
    paternitytesting_9: "Father and son/daughter",
    paternitytesting_10: "Mother and son/daughter",
    paternitytesting_11: "Brothers and sisters",
    paternitytesting_12: " (same father & mother)",
    paternitytesting_13: "Uncle and nephew",
    paternitytesting_14: "Type of Samples Accepted",
    paternitytesting_15: "Blood",
    paternitytesting_16: "Buccal Swab",
    paternitytesting_17: "Finger Nail",
    paternitytesting_18: "Blood/Semen Spot",
    paternitytesting_19: "5-10 Hairs with Follicles",
    paternitytesting_20: "Turnaround Time",
    paternitytesting_21: "3-5 Working Days",
    paternitytesting_22: "FAQ",
    paternitytesting_23: "Is the paternity test report confidential?",
    paternitytesting_24: "Yes, all personal information provided by customers is strictly confidential. Without a written consent from the test subject, the paternity test result will never be disclosed to any third party.",
    paternitytesting_25: "How accurate is the paternity test?",
    paternitytesting_26: "If the parent-child relationship is met, the accuracy is as high as 99.99% or more. When the parent-child relationship is excluded (i.e. at least two loci will not be match), the accuracy is 100%.",
    paternitytesting_27: "What is the difference between a paternity test for private use and legal use?",
    paternitytesting_28: "There is no difference in accuracy. Paternity reports for private use cannot be used as legal documents. Reports for legal use can be used for various formal purposes, and a third party must be present to witness the sample collection.",
  },
  others: {
    others_1: "Buy baby clothes and shoes,",
    others_2: "don't forget about their health",
    others_3: "Expecting a baby",
    others_4: "You and your partner quited coffee, quited smoking and drinking, adjusted your body, and prepared for a new life.",
    others_5: "Friends and families congratulated you, bought baby shirts and trousers and baby gold jewelry. Everyone prayed that he has a perfect life.",
    others_6: "But, did you miss one thing??",
    others_7: "Your baby's health!",
    others_8: "Diseases due to your carelessness?",
    others_9: "It seems that you are healthy, but you may bring risk to your baby. If you miss pre-pregnancy genetic tests, carry genes of hereditary diseases, your baby may have diseases!",
    others_10: "Don't want to leave regrets??",
    others_11: "Let us take you together to prepare for the health of your baby!",
    others_12: "No matter boys or girls, they are all your beloved.",
    others_13: "No need to waiting for ultrasound, get yourself prepared as early as possible.",
    others_14: "Focus on fetal chromosome, lowering the risk of chromosomal abnormalities.",
    others_15: "Screen for Down's syndrome (T21), Edward's syndrome (T18) and Patau's syndrome (T13).",
    others_16: "Paternity test can be done before giving birth without the risk of miscarriage.",
    others_17: "Result is as accurate but you don't have to wait for a long time.",
    others_18: "No matter offspring or siblings, paternity test helps you confirm family bonding.",
    others_19: "Various samples accepted. Privacy protected. Safe and accurate!",
    others_20: "Focus on over 100 monogenic diseases.",
    others_21: "Reduce the possibility of death, deformity or disability for the next generation.",
    others_22: "A little earlier,",
    others_23: "a little more possibility of life",
    others_24: "You have a lot to",
    others_25: "look forward to at your 30s",
    others_26: "Starting a family with your lovely partner, child and pet.",
    others_27: "You always want more: see your kids babbling, attend their graduation, grow old with your spouse and walk together……",
    others_28: "But there are always some hidden dangers, like CANCER.",
    others_29: "Act earlier, stay",
    others_30: "away from cancer",
    others_31: "Early screening of cancer can avoid cancer from happening, allow early treatment and prevent cancer recurrent.",
    others_32: "Don't want to let cancer ruins your life?",
    others_33: "There is a lot you can do!",
    others_34: "Focus on 18 cancers, 79 cancer genes.",
    others_35: "Reveal genetic risks for cancer and help with prevention.",
    others_36: "New ctDNA technology to keep track of cancer progression.",
    others_37: "Early detection of recurrence is associated with better prognosis.",
    others_38: "Love yourself,",
    others_39: "protect your loved one",
    others_40: "You are cautious about baby's health and want to give them the most comprehensive protection",
    others_41: "Since your baby was born, you took him for vaccination on time.",
    others_42: "Yet do you know vaccine is not valid throughout the entire life?",
    others_43: "Understand the protection of vaccines against infectious diseases.",
    others_44: "The most romantic thing you can do is to stay healthy",
    others_45: "You may have all kinds of romantic fantasies with your lover.",
    others_46: "But apart from accidental pregnancy, you may also worry about sexually transmitted infection (STI)!",
    others_47: "A rapid test can protect you and your partner before it happens.",
    others_48: "Vaccination may not be effective forever. Once infected, it can be fatal.",
    others_49: "Test 12 kinds of vaccine antibodies to understand your immunity.",
    others_50: "Intimate contact with your partner may lead to STIs. Occupational contact with blood is also risky.",
    others_51: "For yourself and your partner, check regularly.",
    others_52: "Learn more about your story of life,",
    others_53: "start a new lifestyle",
    others_54: "Do you remember these moments?",
    others_55: "You won a marathon. You got red after drinking.",
    others_56: "You were allergic to peanuts. You were worried about your father's heart disease.",
    others_57: "Your body indeed ",
    others_57s: "has all these codes",
    others_58: "Your genetic code controls your talent. Your body also has signal of hidden allergy.",
    others_59: "Even the risk of genetic diseases is documented within your family tree.",
    others_60: "Now, new lifestyle is gradually prevailing. See how you can enjoy a healthy lifestyle.",
    others_61: "Focus on 5 main areas and 70 talent potentials.",
    others_62: "Understand your baby's talents and educate them according to their aptitude.",


  },
  use_way: {
    Title: 'Terms of Use',
    Pravicy: 'Privacy Policy'
  },

  Mthfr: {
    Title: 'MTHFR Gene Test',

    // P1_Title: "Take folic acid scientifically, take care of the mother and baby",
    P1_Title: "Take folic acid scientifically, caring for the would-be mothers and babies",
    // P1_SubTitle: "Folic acid is necessary before and during pregnancy, but do yo know exactly how much you should take it?",
    P1_SubTitle: "Folic acid is necessary before and during pregnancy, but do you know exactly how much folic acid you should take?",

    P2_Title: "What is Folic Acid?",
    // P2_Content: "Folic acid, also known as vitamin B9, is a water-soluble vitamin. It cannot be synthesized de novo by the body, and mus be obtained either from diet or supplementation. Folic acid is very important because it can help prevent neural tube defects (NTDs) in the offspring. The risk of NTDs will be increased if the pregnant woman fails to provide the fetus with enough folic acid at the early stage of pregnancy. Moreover, maternal anemia, miscarriage and preterm birth will likely ensure.",
    P2_Content: "Folic acid, also known as vitamin B9, is a water-soluble vitamin. It cannot be synthesized internally by the body, and must be obtained either from diet or supplementation. Folic acid is very important because it can help prevent neural tube defects (NTDs) in the offspring. The risk of NTDs will be increased if the pregnant woman fails to provide the fetus with enough folic acid at the early stage of pregnancy. Moreover, maternal anemia, miscarriage and preterm birth would be more likely to happen.",

    P3_Title: "Folic Acid Deficiency",
    P3_Content: "Folic acid, a critical cofactor in one-carbon metabolism, is essential for DNA replication, cell growth and division, and is required for growth and development of the fetus. Therefore, low intake of folic acid increases the risk of pregnancy complications such as maternal anemia and the incidence of undesirable effects including miscarriage and preterm birth.",
    p3_2_Title: "Folic Acid Deficiency May Cause：",
    P3_2_1_1: "Fetus",
    P3_2_1_2: "neural tube defects, oral clefts, congenital heart disease",
    P3_2_2_1: "Pregnant Woman",
    P3_2_2_2: "anemia, preterm birth",

    P4_Title: "Risks of High-dose Folic Acid Supplementation",
    P4_Content: "High-dose folic acid supplementation may cause the accumulation of unmetabolized folic acid which raises about the potentially untoward effects to human body",
    p4_2_Title: "Risks of High-dose Folic Acid Supplementation",
    P4_2_1: "Mask vitamin B12 deficiency (pernicious anemia)",
    // P4_2_2: "Raised about the potentially untoward effects with regard to cancer, depression, and cognitive impairment",
    P4_2_2: "Elevate the risks of cancer, depression, cognitive impairment, etc",

    P5_Title: "Why you need test for MTHFR gene variants?",
    // P5_Content: "To become metabolically active, folic acid must be converted to the biologically active L-methylfolate by the enzyme methylenetetrahydrofolate reductase (MTHFR). In varying degrees, MTHFR C677T and A1298C heterozygous and homozygous variants show decreased enzyme activity and L- methylfolate found in those with the wild-type. Therefore, women with MTHFR C677T and A1298C variants are advised to increase the intake of folic acid.",
    P5_Content: "Folate must be metabolized into 5-Methyltetrahydrofolate (5-MTHF) so as to be effectively utilized by the human body. When the MTHFR gene mutates, the activity of the MTHFR enzyme decreases, making it unable to efficiently convert folate into its usable form. Therefore, individuals with MTHFR mutations are advised to increase their folate intake.",

    // P6_Title: "The Proportion of Genotypes in East Asian Populations",
    P6_Title: "The Proportions of different MTHFR variants in East Asian populations",
    // P6_Content: "The database shows that the ratio of mutants to wild-type of MTHFR gene is about 0.3 to 0.7 in the East Asian population.",
    P6_1_1: "SNP",
    P6_1_2: "MTHFR-C677T",
    P6_1_3: "MTHFR-A1298C",
    P6_2_1: "Genetype",
    P6_2_2: "CC (wild-type); CT (heterozygous variant); TT (homozygous variant)",
    P6_2_3: "AA (wild-type); AC (heterozygous variant); CC (homozygous variant)",

    P7_Title: "What are tested?",
    P7_1_1: "Gene",
    P7_1_2: "MTHFR",
    P7_1_3: "MTHFR",
    P7_2_1: "Variants",
    P7_2_2: "C677T",
    P7_2_3: "A1298C",
    P7_3_1: "Gene Function",
    P7_3_2: "Encodes key enzymes in folic acid metabolism;",
    P7_3_3: "Maintain normal homocysteine levels.",

    // P8_Title: "Take Folic Acid Scientifically",
    P8_Title: "Ways of supplementation",
    P8_Content: "MTHFR gene test aims at detecting two common variants (C677T&A1298C) of the MTHFR gene, which helps you know more about your MTHFR enzyme activity and then you can take folic acid scientifically. ",
    P8_1: "SNP\tGenotype\tGenotype\tEnzyme Activity\tFolic Acid Needs",
    // P8_2: "MTHFR-C677T\tCC\tWild-type\tNormal\tNormal",
    P8_2: "MTHFR-C677T\tCC\tHomozygous wild\tNormal\tNormal",

    // P8_3: "MTHFR-C677T\tCT\tHeterozygous Variant\tDecreased\tHigher",
    P8_3: "MTHFR-C677T\tCT\tHeterozygous\tDecreased\tHigher",

    // P8_4: "MTHFR-C677T\tTT\tHomozygous Variant\tDecreased\tHigher",
    P8_4: "MTHFR-C677T\tTT\tHomozygous mutant\tDecreased\tHigher",

    // P8_5: "MTHFR-A1298C\tAA\tWild-type\tNormal\tNormal",
    P8_5: "MTHFR-A1298C\tAA\tHomozygous wild\tNormal\tNormal",

    // P8_6: "MTHFR-A1298C\tAC\tHeterozygous Variant\tDecreased\tHigher",
    P8_6: "MTHFR-A1298C\tAC\tHeterozygous\tDecreased\tHigher",

    // P8_7: "MTHFR-A1298C\tCC\tHomozygous Variant\tDecreased\tHigher",
    P8_7: "MTHFR-A1298C\tCC\tHomozygous mutant\tDecreased\tHigher",

    P8_2_1: "Normal Folic Acid Needs",
    P8_2_2: "400μg per day",
    P8_2_3: "Higher Folic Acid Needs",
    P8_2_4: "400-1000μg per day",
    P8_3_1: "Remarks:",
    P8_3_2: "1. \tThe upper limit for folic acid is set at 1000μg and consumption above this level may mask vitamin B12 deficiency (pernicious anemia).",
    P8_3_3: "2. \tFor women with a history of neural tube defects, it is necessary to consult the doctor.",


    P9_Title: "Pathway for Folic Acid Supplementation",
    // P9_Content: "Base on the MTHFR enzyme activity related with the genotype of two two common variants (C677T&A1298C), you can choose the supplementation pathway suitable for yourself.",
    P9_Title2: "Strengths",
    P9_Title3: "Weaknesses",
    P9_1_Title: "Dietary",
    P9_1_Title2: "Folate",
    P9_1_1: "Food source;",
    P9_1_2: "Without concern for upper limit;",
    P9_1_3: "Hard to mask vitamin B12 deficiency.",
    P9_1_4: "Unstable;",
    P9_1_5: "Susceptibal to destruction by food processing and preparation;",
    P9_1_6: "Low bioavailability.",
    P9_2_Title: "Sythetic",
    P9_2_Title2: "Folic Acid",
    P9_2_1: "Low-tech;",
    P9_2_2: "Low cost;",
    P9_2_3: "Stable.",
    P9_2_4: "High-dose folic acid supplementation masks vitamin B12 deficiency;",
    P9_2_5: "High-dose folic acid supplementation is harmful;",
    P9_2_6: "Low bioavailability.",
    P9_3_Title: "L-5-MTHF",
    P9_3_Title2: "",
    P9_3_1: "Stabel and prevent the potential negative effects of unmetabolized folic acid;",
    P9_3_1_2: "",
    P9_3_2: "Well absorbed, high bioavailability;",
    P9_3_3: "Reduce the potential for masking vitamin B12 deficiency.",
    P9_3_4: "High-tech;",
    P9_3_5: "High cost.",

    P10_Title: "Target Group",
    P10_1: "Women before or during pregnancy",
    P10_2: "Women who have previously given birth to babies with neural tube defects",
    P10_3: "Women who have experienced recurrent miscarriage, preterm birth and had deformed foetus",
    P10_4: "Women who have history of cardiovascular disease",
    P10_5: "Women who have history of anemia",

    P11_Title: "Test Procedure",
    P11_1: "1. Sample Collection",
    P11_2: "2. Check Client's information",
    P11_3: "3. DNA Extraction",
    P11_4: "4. DNA Quality Test",
    // P11_5: "5. Real Time PCR-SNP",
    P11_5: "5. SNP genotyping",
    P11_6: "6. Data Analysis",
    // P11_7: "7. Part 1 Issue Report",
    P11_7: "7. Registrated MLT I",
    P11_8: "8. Mail Report",

    P12_1_Title: "Sample Requirements",
    P12_1_1: "6mL EDTA Blood",
    P12_2_Title: "Turnaround Time",
    // P12_2_1: "1 Working Day",
    P12_2_1: "5 Working Days",

    P13_Title: "References",
    P13_1: "1.\tDivision of Cancer Epidemiology and Genetics, National Cancer Institute.",
    P13_2: "2.\t《围受孕期增补叶酸预防神经管缺陷指南(2017)》",
    P13_3: "3.\tGreenberg J A, etc. Reviews in Obstetrics and Gynecology, 2011, 4(2): 52.",
    P13_4: "4.\tScaglione F, etc. Xenobiotica, 2014, 44(5): 480-488.",
    P13_5: "5.\tCenters for Disease Control and Prevention (2020). Retrieving from https://www.cdc.gov/ncbddd/folicacid/mthfr-gene-and-folic-acid.html.",
    P13_6: "6.\tNational Health Commission of the PRC (WS/T 578.5—2018). Chinese dietary reference intakes—Part 5: Water-soluble vitamin. ",
    P13_7: "7.\tWeisberg I, etc. Molecular genetics and metabolism, 1998, 64(3): 169-172.",
    P13_8: "8.\tRS1801133 RefSNP report - dbSNP - NCBI (2018). National Center for Biotechnology Information. Rechieving from https://www.ncbi.nlm.nih.gov/snp/rs1801133.",
    P13_9: "9.\tRS1801131 RefSNP report - dbSNP - NCBI (2018) National Center for Biotechnology Information. Rechieving from https://www.ncbi.nlm.nih.gov/snp/rs1801131.",
    P13_10: "10.\tLiwinski T, Lang UE. Folate and Its Significance in Depressive Disorders and Suicidality: A Comprehensive Narrative Review. Nutrients. 2023;15(17):3859. Published 2023 Sep 4. doi:10.3390/nu15173859.",
    P13_11: "11.\tMorris MC, Evans DA, Bienias JL, et al. Dietary Folate and Vitamin B12 Intake and Cognitive Decline Among Community-Dwelling Older Persons. Arch Neurol. 2005;62(4):641–645. doi:10.1001/archneur.62.4.641.",
    P13_12: "12.\tPieroth R, Paver S, Day S, Lammersfeld C. Folate and Its Impact on Cancer Risk. Curr Nutr Rep. 2018;7(3):70-84. doi:10.1007/s13668-018-0237-y.",
  }


};

export {
  MessageEn
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js